






import Vue, { PropType } from 'vue';

import {
  Brand,
} from 'mostra';

export default Vue.extend({
  name: 'g-brand-preview-form',
  props: {
    brandId: {
      type: String as PropType<string>,
      required: true,
    },
    brand: {
      type: Object as PropType<Brand>,
      required: true,
    },
  },
  computed: {
    src(): string {
      return `/ssr/br/${this.brandId}?pv=1`;
    },
  },
});
